import Label, { LabelVariant } from '@/components/elements/Label/Label';
import { useAssocationDrawerContext } from '@/features/associations-drawer/AssociationDrawer.hooks';
import { isSistaminuten as isSistaminutenInstance } from '@/helpers';
import { _s } from '@/locale';
import { SearchPlace } from '@/types/api/services/search';
import { Fragment } from 'react/jsx-runtime';

type CardTagsProps = {
  place: SearchPlace;
  source?: string;
  hideTag?: { [key in LabelVariant]?: boolean };
};

const CardTags = ({ place, hideTag, source }: CardTagsProps) => {
  const associationManager = useAssocationDrawerContext();
  const { about, topSearch, distance, associations } = place;
  const {
    campaign: hideCampaign = false,
    wellness: hideWellness = false,
    discount: hideDiscount = false,
  } = hideTag || {};

  const isSistaminuten = isSistaminutenInstance() || Boolean(place.lastMinuteDiscount);

  const hasDiscount =
    !isSistaminuten && !topSearch && about.settings && about.settings.topOfSearch && source === 'serp-page-top';
  const hasRocket = !isSistaminuten && topSearch;
  const hasCampaign = !isSistaminuten && about?.settings?.hasCampaigns && !hideCampaign;
  const hasSistaminutenDiscount = isSistaminuten && place.lastMinuteDiscount > 0 && !hideDiscount;
  const hasKlarna = !isSistaminuten && about?.settings?.hasKlarna;
  const hasQliro = !isSistaminuten && about?.settings?.hasQliro;
  const hasGiftCard = !isSistaminuten && about?.settings?.sellsGiftCard;
  const hasWellnessCard = !isSistaminuten && about?.settings?.wellness && !hideWellness;
  const hasAssociation = associations?.length;
  // dont show certificate and association at the same time
  const hasCertificate = !isSistaminuten && about?.settings?.displayCertificates && !hasAssociation;

  /**
   * do not allow labels to shrink when no available space, instead allow them to overflow
   * with scroll
   */
  const labelClasses = 'flex-shrink-0';

  const handleShowPlaceAssociations = (e) => {
    e.stopPropagation();
    e.preventDefault();
    associationManager.onOpen(place);
  };

  if (
    hasCampaign ||
    hasRocket ||
    hasDiscount ||
    hasSistaminutenDiscount ||
    hasKlarna ||
    hasQliro ||
    hasCertificate ||
    hasGiftCard ||
    hasWellnessCard ||
    associations?.length ||
    hasAssociation ||
    distance
  ) {
    return (
      <Fragment>
        <div className="gap-xs no-scrollbar rounded-xs flex flex-row overflow-x-scroll sm:flex-wrap">
          {hasSistaminutenDiscount && (
            <Label
              className={labelClasses}
              size="lg"
              variant="discount"
              icon={{ variant: 'smt', color: 'white' }}
              label={_s('UpToDiscountPercentage', { discount: place?.lastMinuteDiscount })}
            />
          )}
          {hasDiscount && <Label className={labelClasses} size="lg" variant="discount" label={_s('20discount')} />}
          {hasRocket && <Label className={labelClasses} size="lg" variant="rocket" />}
          {hasCampaign && <Label className={labelClasses} size="lg" variant="campaign" />}
          {hasKlarna && <Label className={labelClasses} size="lg" variant="klarna" />}
          {hasQliro && <Label className={labelClasses} size="lg" variant="qliro" />}
          {hasCertificate && <Label className={labelClasses} size="lg" variant="certificate" />}
          {hasGiftCard && <Label className={labelClasses} size="lg" variant="giftcard" />}
          {hasWellnessCard && <Label className={labelClasses} size="lg" variant="wellness" />}
          {hasAssociation && (
            <button onClick={handleShowPlaceAssociations} className="inline-flex outline-none">
              <Label className={labelClasses} size="lg" variant="org" />
            </button>
          )}
          {distance && <Label className={labelClasses} size="lg" label={`${distance}`} />}
        </div>
      </Fragment>
    );
  }
  return null;
};

export default CardTags;
